import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

const getUnreadVoicemailsCount = (voicemails) => {
  return voicemails.reduce((acc, item) => {
    if (!item.isRead && !item.isHandled) {
      return acc + 1;
    }

    return acc;
  }, 0);
};

export const voicemails = createReducer(
  {
    list: [],
    unreadCount: 0,
  },
  {
    [types.GET_VOICEMAILS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        unreadCount: getUnreadVoicemailsCount(action.voicemails),
        list: action.voicemails.sort((a, b) => {
          return b.timestamp - a.timestamp;
        }),
      });

      return newState;
    },
    [types.GET_VOICEMAILS_FAIL](state) {
      const newState = Object.assign({}, state, {
        unreadCount: 0,
        list: [],
      });

      return newState;
    },
    [types.MARK_VOICEMAIL_START](state) {
      const newState = Object.assign({}, state, {
        vmloader:true
      });
      return newState;
    },
    [types.MARK_VOICEMAIL_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        vmloader:false
      });
      return newState;
    },
    [types.MARK_VOICEMAIL_SUCCESS](state, action) {
      const newList = state.list.concat();

      for (let i = 0, l = newList.length; i < l; i += 1) {
        if (newList[i].id === action.id) {
          newList[i].isRead = action.isRead;
        }
      }

      const newState = Object.assign({}, state, {
        list: newList,
        vmloader:false,
        unreadCount: getUnreadVoicemailsCount(newList),
      });

      return newState;
    },
    [types.GET_CONVERSATION_MESSAGE](state,action) {
      if(action.action.type === '/voicemail'){
        const { data } = action.action;
        const newList = state.list.concat();
        newList.push(data);
        const newState = Object.assign({}, state, {
        unreadCount: getUnreadVoicemailsCount(newList),
        list: newList.sort((a, b) => {
          return b.timestamp - a.timestamp;
        }),
      });

      return newState;
    }else{
      return state;
    }
    }
  },
);

export { voicemails as default };
